// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","container":"Footer_container__R7sXj","text":"Footer_text__27sON","links":"Footer_links__wMgLO"};